import { render } from "./SimpleTable.vue?vue&type=template&id=03f3847e&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=ts"
export * from "./SimpleTable.vue?vue&type=script&lang=ts"

import "./SimpleTable.vue?vue&type=style&index=0&id=03f3847e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03f3847e"

export default script